'use client';

import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';

import Main from './BaseMain';
import SpotMain from './SpotMain';
import { BannerItemFragment } from './query.generated';

interface Props {
  heroCarousel?: BannerItemFragment[];
  promotions?: BannerItemFragment[];
}

const MainPage = (props: Props) => {
  const isSpotOnly = useCheckSpotOnly();
  const isMounted = useMounted();

  if (isSpotOnly && isMounted) {
    return <SpotMain />;
  }

  return <Main {...props} />;
};

export default MainPage;
